import React from 'react';
import { Breadcrumbs, Link, Typography, Box } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';

const UnifiedBreadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getBreadcrumbs = () => {
    const pathnames = location.pathname.split('/').filter((x) => x);
    
    const breadcrumbNameMap = {
      '': 'Home',
      'supervisor': 'Supervisor',
      'chat': 'Chat',
      'hybrid-chat': 'Chat Híbrido',
      'dashboard': 'Dashboard',
      'contacts': 'Contatos',
      'tickets': 'Tickets'
    };

    const breadcrumbs = [
      {
        label: 'Home',
        path: '/',
        clickable: location.pathname !== '/'
      }
    ];

    let currentPath = '';
    pathnames.forEach((pathname, index) => {
      currentPath += `/${pathname}`;
      const isLast = index === pathnames.length - 1;
      
      breadcrumbs.push({
        label: breadcrumbNameMap[pathname] || pathname,
        path: currentPath,
        clickable: !isLast
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs();

  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <Box sx={{ p: 2, backgroundColor: 'grey.50' }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {breadcrumbs.map((breadcrumb, index) => (
          breadcrumb.clickable ? (
            <Link
              key={breadcrumb.path}
              color="inherit"
              onClick={() => navigate(breadcrumb.path)}
              sx={{ cursor: 'pointer', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            >
              {breadcrumb.label}
            </Link>
          ) : (
            <Typography key={breadcrumb.path} color="text.primary">
              {breadcrumb.label}
            </Typography>
          )
        ))}
      </Breadcrumbs>
    </Box>
  );
};

export default UnifiedBreadcrumbs;
